module.exports = {
  "acq-0164": {
    "identifierType": "OTHER",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant_a"
      ]
    }
  },
  "acq-0170": {
    "identifierType": "OTHER",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant_a"
      ]
    }
  },
  "acqly-acq-0172": {
    "identifierType": "OTHER",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant_a",
        "variant_b",
        "variant_c"
      ]
    }
  },
  "acq-0173": {
    "identifierType": "OTHER",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant_a",
        "variant_b",
        "variant_c"
      ]
    }
  }
};